import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M8.25 8.25V1.344C6.346 2.562 4.989 5.164 4.794 8.25H8.25zM14.726 8.25h3.237A8.995 8.995 0 0 0 10.674.162c2.256 1.526 3.852 4.548 4.052 8.088zM9.75 1.344V8.25h3.456c-.195-3.086-1.552-5.688-3.456-6.906zM.038 9.75a8.992 8.992 0 0 0 8.212 8.212v-5.151l-2.22 2.22L6 15v-2.061l3-3 3 3V15l-.03.03-2.22-2.22v5.151a8.991 8.991 0 0 0 8.212-8.212H.038zM3.274 8.25c.2-3.54 1.796-6.562 4.052-8.088A8.996 8.996 0 0 0 .037 8.25h3.237z" />
  </svg>
);

export default SvgComponent;
